import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard.component';

import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/components/shared.module';

@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule,
    RouterModule,
    SharedModule
  ],
  exports: [
    DashboardComponent
  ]
})

export class AppviewsModule { }



// WEBPACK FOOTER //
// ./src/app/views/appviews/appviews.module.ts